import { render, staticRenderFns } from "./TextScroller.vue?vue&type=template&id=0237c91a&scoped=true"
import script from "./TextScroller.vue?vue&type=script&lang=js"
export * from "./TextScroller.vue?vue&type=script&lang=js"
import style0 from "./TextScroller.vue?vue&type=style&index=0&id=0237c91a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237c91a",
  null
  
)

export default component.exports